import React, { useEffect, useState } from "react";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Settings = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState({
    year: "",
    coin: "",
    baseRate: "",
    refallRate: "",
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (result.status && result.data) {
        setData(result.data);
      } else {
        throw new Error(result.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setFormData(data[index]);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const current = data[editingIndex];
    const supplyId = current._id || current.id; // Ensure correct ID field

    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply/${supplyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Update failed");

      const updated = [...data];
      updated[editingIndex] = formData;
      setData(updated);
      setEditingIndex(null);
      alert("Supply updated successfully!");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleAddNew = async () => {
    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Add failed");

      setData([...data, result.data]);
      setFormData({ year: "", coin: "", baseRate: "", refallRate: "" });
      alert("New supply added successfully!");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="flex bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6">
          <h2 className="text-3xl font-bold mb-6 text-white">Yearly Coin Supply Settings</h2>

          {/* Form */}
          <div className="bg-gray-800 p-6 rounded shadow mb-6">
            <h3 className="text-xl font-semibold mb-4 text-white">
              {editingIndex !== null ? "Edit Supply" : "Add New Supply"}
            </h3>
            <div className="grid grid-cols-2 gap-4">
              <input
                type="number"
                name="year"
                placeholder="Year"
                value={formData.year}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
              />
              <input
                type="number"
                name="coin"
                placeholder="Total Coins"
                value={formData.coin}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
              />
              <input
                type="number"
                step="0.01"
                name="baseRate"
                placeholder="Base Rate"
                value={formData.baseRate}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
              />
              <input
                type="number"
                step="0.01"
                name="refallRate"
                placeholder="Referral Rate"
                value={formData.refallRate}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full mb-2 bg-gray-700 text-white"
              />
            </div>
            <div className="mt-4">
              <button
                onClick={editingIndex !== null ? handleSave : handleAddNew}
                className="bg-yellow text-white px-4 py-2 rounded"
              >
                {editingIndex !== null ? "Save Changes" : "Add Supply"}
              </button>
            </div>
          </div>

          {/* Table */}
          {loading && <p className="text-gray-400">Loading data...</p>}
          {error && <p className="text-red-500">{error}</p>}
          {!loading && data.length > 0 && (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-gray-800 rounded shadow text-left">
                <thead className="bg-yellow">
                  <tr>
                    <th className="py-2 px-4 ">Year</th>
                    <th className="py-2 px-4 ">Total Coins</th>
                    <th className="py-2 px-4 ">Base Rate</th>
                    <th className="py-2 px-4 ">Referral Rate</th>
                    <th className="py-2 px-4 ">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index} className="border-b border-gray-900 hover:bg-gray-700 transition cursor-pointer text-gray-300">
                      <td className="py-2 px-4 ">{item.year}</td>
                      <td className="py-2 px-4 ">{item.coin.toLocaleString()}</td>
                      <td className="py-2 px-4 ">{item.baseRate}</td>
                      <td className="py-2 px-4 ">{item.refallRate}</td>
                      <td className="py-2 px-4 ">
                        <button
                          className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                          onClick={() => handleEdit(index)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
